module.exports = __webpack_public_path__ + "img/pencil.71bbe597.svg";